import { render, staticRenderFns } from "./Materials_and_Finishes.vue?vue&type=template&id=177835b9&scoped=true"
import script from "./Materials_and_Finishes.vue?vue&type=script&setup=true&lang=js"
export * from "./Materials_and_Finishes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Materials_and_Finishes.vue?vue&type=style&index=0&id=177835b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177835b9",
  null
  
)

export default component.exports